import React, {useState,useEffect,useRef} from 'react'
import { Formik, Field } from 'formik'
import { Table,Button,Icon,Form,Select,Input,List,Image,Label,TextArea } from 'semantic-ui-react'

import Paginations from '../../../config/pagination'
import EntryList from '../../../config/entries'
import {WindowReload, WindowURLAdmin, WindowLocationAdmin} from '../../../config/settings'
import Alertmessage from '../../../config/alert'
import axios from 'axios'
import renderHTML from 'react-render-html'
import {insertvalidations} from './validate'


export default function AdministratorComponent(props) {

	const [alert,setalert] = useState(false);
	const [Alertcontent,setAlertcontent] = useState({});
	function Alertclose(){setalert(false);}
	function Alertconfirm(data){if(data.confirm==true){setalert(false);}}
	function Alertdelete(data){
		if(data.delete==true){
			DeleteRecord(data.id);
		}
	}
	function DeleteConfirmation(id){
		setAlertcontent({intent:'delete',settings:{id:id,centered:false,icon:'warning',title:'Delete Confirmation!',html:'This process is not ireversible. Once you continue the process, the record will be deleted on the database.',footer:'none'}});
		setalert(true);
	}


	/* ------------------------------------------
		List with paginations
	---------------------------------------------*/
	const [search, setsearch]  = useState({
			email:'',
			status:''
	});

	const [list, setlist] = useState([]);
	const [pagenumber, setpagenumber] = useState(1);
	const [totaldata, settotaldata] = useState(0);
	const [entry, setentry] = useState(0);
	const [entrytype, setentrytype] = useState('');

	const [paginations, setpaginations] = useState({
			paginations:[{
			listnav:[],
			pageinfo:'',
			limit_page:'',
			total_page:'',
			total_records:'',
			current_page:'',
			startPage:'',
			endPage:'',
			ellipseLeft:'',
			ellipseRight:'',
			}]
	});

	function pagenumberfunction(page){
				TableList(page,search);
		}
		function listreload(){
				TableList(pagenumber,search);
		}
		function searchProcess(){
			  TableList(pagenumber,search);
		}
		function TableList(page,searchstr){

			 setAlertcontent({intent:'inline_spinner',settings:{centered:true,icon:'spinner',title:'Loading',html:"This won't take long, please wait...",footer:'none'}});
			 setalert(true);

				let formData = new FormData();
				formData.append('type','list');
				formData.append('search',JSON.stringify(searchstr));
				formData.append('page',page);
				axios.post('/admin/users/http.php',formData)
				.then(function (response) {
						let obj = response.data;
						setentry(obj.entries.val);
						setentrytype(obj.entries.type);
						setlist(obj.listtable);
						setpaginations(obj.paginations);
						settotaldata(obj.paginations.paginations.total_records);
						setalert(false);

				})
				.catch(function (error){
					setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Server Error!',html:"Problem connecting to the server. Contact the administrator.",footer:'yes'}});
					setalert(false);
				});
		}

		function handleSubmitForm(values, props){
			TableList(pagenumber,values);
	  }

	 /* ------------------------------------------
			List with paginations end
		---------------------------------------------*/

	/*-------------------------------------------------------------------------
	 Forms: Adding and Updating
	--------------------------------------------------------------------------*/
	const [state,setstate] = useState({
		id:'',
		email:'',
		password:'',
		fullname:'',
		position:'',
		status:'Active',
		submit:'add',
	});
	function handleSubmitForm(values, props){

		setAlertcontent({intent:'inline_spinner',settings:{centered:true,icon:'spinner',title:'Processing',html:"This won't take long, please wait...",footer:'none'}});
		setalert(true);

		let formData = new FormData();
		formData.append('type',values.submit);
		formData.append('info',JSON.stringify(values));
		axios.post('/admin/users/http.php',formData)
		.then(function (response) {

			let obj = response.data;

			if(obj=='success'){
				setAlertcontent({intent:'alert',settings:{centered:false,icon:'success',title:'Congratulations',html:"Data successfully saved."}});
				setalert(true);
				setTimeout(function() {
					WindowLocationAdmin('/users');
				},2000);
				return false;
			}

			if(obj=='error'){
				setAlertcontent({intent:'alert',settings:{centered:false,icon:'error',title:'Saving Error!',html:"Data not successfully saved. Please try again later.",footer:'yes'}});
				setalert(true);
				setTimeout(function() {WindowReload();},2000);
				return false;
			}

			setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Input Error!',html:"Please correct the input errors.",footer:'yes'}});
			setalert(true);
			setTimeout(function() {setalert(false);},2000);
			Object.keys(obj).forEach(function(key) {
        props.setErrors(obj);
      });

		})
		.catch(function (error){
			setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Server Error!',html:"Problem connecting to the server. Contact the administrator.",footer:'yes'}});
			setalert(true);
			setTimeout(function() {WindowReload();},2000);
		});
	}




	/*-------------------------------------
	 Delete
	--------------------------------------*/
	function DeleteRecord(id){

		setAlertcontent({intent:'inline_spinner',settings:{centered:true,icon:'spinner',title:'Deleting',html:"Deleting record is on process, please wait...",footer:'none'}});
		setalert(true);

		let formData = new FormData();
		formData.append('type','delete');
		formData.append('id',id);
		axios.post('/admin/users/http.php',formData)
		.then(function (response) {
				let obj = response.data;
				if(obj=='success'){
					setAlertcontent({intent:'alert',settings:{centered:false,icon:'success',title:'Congratulations',html:"Record successfully deleted."}});
					setTimeout(function() {
						WindowLocationAdmin('/users');
						setalert(false);
					},2000);
				}else{
					setAlertcontent({intent:'alert',settings:{centered:false,icon:'error',title:'Delete Failed',html:"Record not successfully deleted."}});
					setTimeout(function() {setalert(false);},2000);
				}
		})
		.catch(function (error){
			setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Server Error',html:"Problem connecting to the server."}});
			setalert(true);
			setTimeout(function() {setalert(false);},2000);
		});
}


	/*-------------------------------------
	 Updating Form
	--------------------------------------*/
	function DetailsData(id){
		setAlertcontent({intent:'inline_spinner',settings:{centered:true,icon:'spinner',title:'Processing',html:"This won't take long, please wait...",footer:'none'}});
		setalert(true);
		let formData = new FormData();
		formData.append('type','details');
		formData.append('id',id);
		axios.post('/admin/users/http.php',formData)
		.then(function (response) {
				let obj = response.data;
				if(obj==0){
					WindowLocationAdmin('/users');
					return false;
				}else{
					setstate({
						...state,
						id:obj.id,
						email:obj.email,
						password:obj.plain_password,
						fullname:obj.fullname,
						position:obj.position,
						status:obj.status,
						submit:'update',
					});
					setalert(false);
					return false;
				}

		})
		.catch(function (error){
			setAlertcontent({intent:'alert',settings:{centered:false,icon:'warning',title:'Server Error',html:"Problem connecting to the server."}});
			setalert(true);
			setTimeout(function() {setalert(false);},2000);
		});
	}


	useEffect(()=>{
		TableList(pagenumber,search);
		if(props.match.params.id){
			DetailsData(props.match.params.id);
		}
	},[]);


	return (
		<React.Fragment>
      <div className="page-wrapper">
				{alert&&<Alertmessage close={Alertclose} data={Alertcontent} confirm={Alertconfirm} delete={Alertdelete}/>}
				<Form>
					<Formik
					  enableReinitialize
						initialValues={state}
						validationSchema={insertvalidations}
						onSubmit={handleSubmitForm}
						render={formProps => {
						const { values, isSubmitting, errors, handleChange, handleBlur, handleSubmit, isValid, touched, setFieldValue } = formProps
						return(
			         <div className="panel hasbottom">
			            <div className="panel-header">User Admin</div>
			            <div className="panel-body">
									 <div className="formwrapper50">

										 <div className="inlinform">
										 		<div><label>Email</label></div>
												<div>
													<Form.Group widths="equal">
														<Field name="email">
																{({ field, form }) => (
																<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																	<Input {...field} onChange={handleChange}/>
																	{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																</Form.Field>
																)}
														</Field>
													</Form.Group>
												</div>
										 </div>{/*.inlinform*/}

										 <div className="inlinform">
										 		<div><label>Password</label></div>
												<div>
													<Form.Group widths="equal">
														<Field name="password">
																{({ field, form }) => (
																<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																	<Input {...field} onChange={handleChange}/>
																	{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																</Form.Field>
																)}
														</Field>
													</Form.Group>
												</div>
										 </div>{/*.inlinform*/}

										 <div className="inlinform">
										 		<div><label>Fullname</label></div>
												<div>
													<Form.Group widths="equal">
														<Field name="fullname">
																{({ field, form }) => (
																<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																	<Input {...field} onChange={handleChange}/>
																	{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																</Form.Field>
																)}
														</Field>
													</Form.Group>
												</div>
										 </div>{/*.inlinform*/}

										 <div className="inlinform">
										 		<div><label>Position</label></div>
												<div>
													<Form.Group widths="equal">
														<Field name="position">
																{({ field, form }) => (
																<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																	<Input {...field} onChange={handleChange}/>
																	{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																</Form.Field>
																)}
														</Field>
													</Form.Group>
												</div>
										 </div>{/*.inlinform*/}

										 <div className="inlinform">
										 		<div><label>Status</label></div>
												<div>
													<Form.Group widths="equal">
														<Field name="status">
															{({ field, form }) => (
																	<Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
																		<Select selectOnBlur={false}
																				{...field}
																				options={[
																						{ key: '0', text: 'Active', value: 'Active' },
																						{ key: '1', text: 'In-Active', value: 'In-Active' },
																				]}
																				onChange={(e, { value }) => setFieldValue(field.name,value)}/>
																		{ form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
																	</Form.Field>
															)}
														</Field>
													</Form.Group>
												</div>
										 </div>{/*.inlinform*/}

									 </div>{/*.formwrapper50*/}
									</div>{/*.panel-body*/}
			            <div className="panel-footer">
									    {values.submit=='update'&&<Button className='red' size='large' icon='close' content='Cancel' href={WindowURLAdmin('/users')}/>}
											<Button className='secondary'  size='large' icon="save" content={values.submit=='update'?'Update Admin':'Save Admin'} onClick={handleSubmit}/>
									</div>
			         </div>

						 )}}/>
					</Form>

					<div className="panel">
						 <div className="panel-header">List Admin</div>
						 <div className="panel-body">
						 	 <div className="table-responsive">
								 <Table celled>
									 <Table.Header>
										 <Table.Row>
											 <Table.HeaderCell>Account</Table.HeaderCell>
											 <Table.HeaderCell>Email</Table.HeaderCell>
											 <Table.HeaderCell>Fullname</Table.HeaderCell>
											 <Table.HeaderCell>Position</Table.HeaderCell>
											 <Table.HeaderCell>Status</Table.HeaderCell>
											 <Table.HeaderCell>Delete</Table.HeaderCell>
											 <Table.HeaderCell>Edit</Table.HeaderCell>
										 </Table.Row>
									 </Table.Header>

									 <Table.Body>
												 {list.length==0&&<Table.Row negative><Table.Cell  colSpan='7' textAlign="center">No record found</Table.Cell></Table.Row>}
												 {list.map(function(data, key){
													 return <Table.Row key={key} className={data.status=='In-Active'?'negative':''}>
															 <Table.Cell>{data.account}</Table.Cell>
															 <Table.Cell>{data.email}</Table.Cell>
															 <Table.Cell>{data.fullname}</Table.Cell>
															 <Table.Cell>{data.position}</Table.Cell>
															 <Table.Cell collapsing>{renderHTML(data.status_text)}</Table.Cell>
															 <Table.Cell collapsing>
																 <Button className='red' size='small'  icon='trash alternate outline' onClick={()=>DeleteConfirmation(data.id)} />
															 </Table.Cell>
															 <Table.Cell collapsing>
																 <Button className='primary' size='small' icon='edit' as="a" href={WindowURLAdmin('/users/'+data.id)}/>
															 </Table.Cell>
													 </Table.Row>
												 })}
										 </Table.Body>
										 {list.length>0&&
											 <Table.Footer fullWidth>
													 <Table.Row>
													 <Table.HeaderCell colSpan='7'>
															 <div className="dash-footer"><Paginations callbackPagination={paginations} callbackPagenumber={pagenumberfunction}/></div>
													 </Table.HeaderCell>
													 </Table.Row>
											 </Table.Footer>
										 }
								 </Table>
								 </div>
						 </div>
					</div>

      </div>
    </React.Fragment>
  )
}
